<nz-spin [nzSpinning]="loading">
    @if (isWorkplaceAbsence(absence)) {
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="{ xs: 1, sm: 1, md: 2 }">
            <nz-descriptions-item nzTitle="Veids">{{ absence.typeName }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Statuss">{{ absence.status }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="No">{{ absence.dateFrom | date: DATE_FORMAT }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Līdz">{{ absence.dateTo | date: DATE_FORMAT }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Darba dienas">{{ absence.workdayCount }}</nz-descriptions-item>
        </nz-descriptions>
    } @else {
        <div class="p-4">
            <div class="mb-2"><strong>Darbinieks:</strong> {{ absence.performer?.fullName || '-' }}</div>
            <div class="mb-2"><strong>Nodaļa:</strong> {{ absence.performer?.departmentName || '-' }}</div>
            <div class="mb-2"><strong>Prombūtnes tips:</strong> {{ absence.absenceType?.name || '-' }}</div>
            <div class="mb-2"><strong>Statuss:</strong> {{ absence.status || '-' }}</div>
            <div class="mb-2"><strong>Sākuma datums:</strong> {{ absence.realStartDate || absence.startDate | date: DATE_FORMAT }}</div>
            <div class="mb-2"><strong>Beigu datums:</strong> {{ absence.realEndDate || absence.endDate | date: DATE_FORMAT }}</div>
            <div class="mb-2"><strong>Kopējais dienu skaits:</strong> {{ absence.totalDays || '-' }}</div>
            <div class="mb-2"><strong>Darba dienu skaits:</strong> {{ absence.totalWorkdays || '-' }}</div>
            @if (absence.signerPerformer) {
                <div class="mb-2"><strong>Rīkojuma parakstītājs:</strong> {{ absence.signerPerformer.fullName || '-' }}</div>
            }
            @if (absence.orderNumber) {
                <div class="mb-2"><strong>Rīkojuma numurs:</strong> {{ absence.orderNumber || '-' }}</div>
            }
            @if (absence.orderDate) {
                <div class="mb-2"><strong>Rīkojuma datums:</strong> {{ absence.orderDate | date: DATE_FORMAT }}</div>
            }
        </div>
    }

    <div *nzModalFooter class="modal-footer">
        @if (isWorkplaceAbsence(absence)) {
            <button nz-button nz-tooltip nzTooltipTitle="Skatīt LUIDAIS" aria-label="Skatīt LUIDAIS" (click)="gotoLuidaisAbsence(absence.id)">
                <span nz-icon nzType="link" nzTheme="outline"></span>
            </button>
        } @else {
            <cl-absence-actions
                [id]="absence.id"
                [performerId]="absence.performerId"
                [status]="absence.status"
                (absenceChanged)="absenceChanged.emit()"
            ></cl-absence-actions>
        }
    </div>
</nz-spin>
